// 화면 권한 값(계약 PERMISSIONS 7): GET /auth/introspect 의 profile.perms·modes, 이름표 GET /perm-catalog?app=<앱>.
// 응답에 perms·modes 가 없으면(옛 inapi·W2 합류 전) null 로 두고 화면은 옛 규칙 그대로(permUi.shouldUseNewRule).
import { reactive } from "vue";
import apiInstance from "@/axios";
import { CLIENT_APP } from "@/utils/clientHeaders";
import { diffSeenKey } from "@/utils/permUi";

// loaded: 한 번이라도 읽어 봤는가(실패 포함) — 라우터·대시보드가 inapi 가 느릴 때 이동마다 다시 기다리지 않게
export const permState = reactive({ perms: null, modes: null, accountId: null, loaded: false });
const labels = {};
let catalogLoaded = false;
let lastReload = 0;

let loading = null;

/** 사이드바·대시보드가 같은 때 불러도 한 번만 읽는다(배경 요청은 이 값을 보고 보냄) */
export function loadPerms() {
  if (!loading) {
    loading = (async () => {
      try {
        // 5초 넘으면 옛 규칙 그대로(화면을 붙잡지 않음)
        const { data } = await apiInstance.get("/auth/introspect", { showGlobalLoading: false, timeout: 5000 });
        permState.perms = Array.isArray(data?.profile?.perms) ? data.profile.perms : null;
        permState.modes = data?.modes && typeof data.modes === "object" ? data.modes : null;
        permState.accountId = data?.accountId || null;
      } catch (error) {
        // 못 읽으면 옛 규칙 그대로(막지 않음)
      }
    })().finally(() => {
      permState.loaded = true;
      loading = null;
    });
  }
  return loading;
}

async function loadCatalog() {
  if (catalogLoaded) return;
  const { data } = await apiInstance.get("/perm-catalog", { params: { app: CLIENT_APP }, showGlobalLoading: false, timeout: 5000 });
  (data?.codes || []).forEach((c) => {
    if (c && c.code) labels[c.code] = c.ko;
  });
  catalogLoaded = true;
}

export const permLabel = (code) => labels[code] || code;

/** 403 PERMISSION_DENIED 뒤 한 번 다시 읽기(10초 안 거듭 오면 다시 부르지 않음 — 반복 금지). 이름표 함수를 돌려줌 */
export async function reloadPerms() {
  if (Date.now() - lastReload > 10000) {
    lastReload = Date.now();
    await Promise.all([loadPerms(), loadCatalog().catch(() => undefined)]);
  }
  return permLabel;
}

/** 옛 규칙과 다른 메뉴 보고(POST /perm/ui-diff) — 계정·코드마다 한 번(localStorage 표시, 비어도 괜찮음) */
export function reportPermUiDiffs(diffs) {
  diffs.forEach((d) => {
    const key = diffSeenKey(permState.accountId, d.code);
    try {
      if (localStorage.getItem(key)) return;
      localStorage.setItem(key, "1");
    } catch (error) {
      // 저장소를 못 쓰면 이번 화면에서만 한 번
    }
    apiInstance.post("/perm/ui-diff", d, { showGlobalLoading: false }).catch(() => undefined);
  });
}
